import React , {useState} from "react";
import "./contact.css";
import {
    ToastContainer,
    toast
}from "react-toastify";
import axios from "axios";

const Contact = (props) => {
    const [formData,setForm] = useState({
        fname : "",
        lname : "",
        email : "",
        subject : "",
        message : "",
        textChange : "Send"
    });
    const {
        fname,
        lname,
        email,
        subject,
        message,
        textChange
    } = formData;
    const handleChange = (text) => (e) => {
        setForm({...formData,[text] : e.target.value});
    }

    const handleSubmit = e => {
        e.preventDefault();
        if(fname && lname && email && subject && message)
        {
            setForm({...formData,textChange : "Sending Email...."});
            axios
            .post("https://arcane-sands-57859.herokuapp.com/contact/message",{
                first_name : fname,
                last_name : lname,
                email : email,
                subject : subject,
                message : message
            })
            .then((response)=> {
                setForm({
                    ...formData,
                    fname : "",
                    lname : "",
                    email : "",
                    subject : "",
                    message : "",
                    textChange : "Send"
                });
                toast.success(response.data.message)
            })
            .catch((err) => {
                setForm({
                    ...formData,
                    fname : "",
                    lname : "",
                    email : "",
                    subject : "",
                    message : "",
                    textChange : "Send"
                });
                toast.error(err.response.data.errors);
            })
        }
        else{
            toast.error("Please fill all the fields");
        }
    }
        return(
            <div className="container-fluid mt-4">
                <ToastContainer />
                <h2 className="contact-heading text-center">Contact Me</h2>
                <p className="contact-text text-center">Get in touch with me</p>
                <div className="row mt-5">
                    <div className="col-md-6 col-l-6 col-sm-12 social-column rounded-1">
                        <div className="form-group form-inline">
                            <i className="fa fa-envelope contact-icons mr-3"></i>
                            <p className="contact-email text-center">shawavisek35@gmail.com</p>
                        </div>
                        <div className="form-group form-inline mt-3">
                            <i className="fa fa-map-signs contact-icons mr-3"></i>
                            <p className="contact-address text-center">Track me here &#128071;&#127996; &#128071;&#127996;</p>
                            <iframe className="mt-3 ml-3" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.7024902757007!2d88.35578231428458!3d22.590227938017957!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277ba55be4f3b%3A0x594752e9af90aab1!2sNutan%20Bazar%2C%2026%2C%20PK%20Tagore%20St%2C%20Jorabagan%2C%20Kolkata%2C%20West%20Bengal%20700006!5e0!3m2!1sen!2sin!4v1590652796576!5m2!1sen!2sin" width="400" height="100" frameborder="0" style={{border:"0"}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                        </div>
                        <div className="form-group form-inline mt-3">
                            <i className="fa fa-user contact-icons mr-3"></i>
                            <p className="contact-address text-center contact-email">Social Media Connections</p><br />
                            <div className="contact-icons2 ml-5">
                                <a href="https://www.facebook.com/profile.php?id=100009567481817"><i className="fa fa-facebook-f facebook"></i></a>
                                <a href="https://www.linkedin.com/in/avisek-shaw-78136b196/"><i className="fa fa-linkedin ml-4 twitter"></i></a>
                                <a href="https://twitter.com/AvisekShaw6?s=09"><i className="fa fa-twitter ml-4 twitter"></i></a>
                                <a href="https://www.instagram.com/indorap_avisek3524/feed/"><i className="fa fa-instagram ml-4 instagram"></i></a>
                            </div>
                            
                            
                        </div>
                    </div>
                    <div className="col-md-6 col-l-6 col-sm-12 form-column rounded-2">
                        <form className="" onSubmit={handleSubmit}>
                            <div className="form-group" >
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6 mt-3">
                                        <input className="form-control input-cl" type="text" placeholder="Enter first name" value={fname} onChange={handleChange("fname")} />
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 mt-3">
                                    <input className="form-control input-cl" type="text" placeholder="Enter last name" value={lname} onChange={handleChange("lname")} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group mt-5">
                                <input type="email" className="form-control input-cl" name="email" placeholder="Email" value={email} onChange={handleChange("email")} />
                            </div>
                            <div className="form-group mt-5">
                                <input type="text" className="form-control input-cl" name="subject" placeholder="Subject of the message" value={subject} onChange={handleChange("subject")} />
                                
                            </div>
                            <div className="form-group mt-5">
                                <textarea type="text" className="form-control input-cl" name="message" placeholder="Message" style={{height: "114px"}} value={message} onChange={handleChange("message")} ></textarea>
                            </div>
                            <div className="form-group mt-5">
                                <button type="submit" className="btn btn-outline-light contact-button">  {textChange}  </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
};

export default Contact;
